module.exports = __webpack_public_path__ + "img/Dr-soft — full.png";